import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Who doesn't love faster tools?...`}</p>
    <h1>{`TL;DR`}</h1>
    <h2>{`conda's mamba`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`conda `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` -y -n base -c conda-forge conda-libmamba-solver`}</code></pre></div>
    <p>{`Basically a rewrite of conda in C++. It's also multithreaded. You can directly install mamba dep solver to use conda as you used to and get faster install experience.`}</p>
    <h2>{`cmake-init`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`cmake-init`}</code></pre></div>
    <p>{`Sit and get boilerplate `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`CMakeLists.txt`}</code>{` file generated with a few typing. You can also get `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`conan`}</code>{` for package manager.`}</p>
    <h2>{`CPM`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cmake"
    }}><pre parentName="div" {...{
        "className": "language-cmake"
      }}><code parentName="pre" {...{
          "className": "language-cmake"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`set`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token variable"
          }}>{`CPM_DOWNLOAD_VERSION`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0.27.2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` 
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`set`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`CPM_DOWNLOAD_LOCATION `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`\${`}</span><span parentName="span" {...{
                "className": "token variable"
              }}>{`CMAKE_BINARY_DIR`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`/cmake/CPM_`}<span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`\${`}</span><span parentName="span" {...{
                "className": "token variable"
              }}>{`CPM_DOWNLOAD_VERSION`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span></span>{`.cmake"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`NOT`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`EXISTS `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`\${`}</span>{`CPM_DOWNLOAD_LOCATION`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`message`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`STATUS `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Downloading CPM.cmake"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`file`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`DOWNLOAD https://github.com/TheLartians/CPM.cmake/releases/download/v`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`\${`}</span><span parentName="code" {...{
            "className": "token variable"
          }}>{`CPM_DOWNLOAD_VERSION`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`/CPM.cmake `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`\${`}</span>{`CPM_DOWNLOAD_LOCATION`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`endif`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`include`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`\${`}</span>{`CPM_DOWNLOAD_LOCATION`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`Copy paste into your `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`CMakeLists.txt`}</code>{` and you get cmake's native "package manager" for free.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "cmake"
    }}><pre parentName="div" {...{
        "className": "language-cmake"
      }}><code parentName="pre" {...{
          "className": "language-cmake"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`CPMAddPackage`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token property"
          }}>{`NAME`}</span>{` spdlog
    GITHUB_REPOSITORY gabime/spdlog
    `}<span parentName="code" {...{
            "className": "token property"
          }}>{`VERSION`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1.7.0`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# ... and then`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`target_link_libraries`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`your_lib
    spdlog`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      